define([
    './_site'
], function (
    Site
) {
    const isScrolledIntoView = function (element, fullyInView) {
        const pageTop = $(window).scrollTop();
        const pageBottom = pageTop + $(window).height();
        const elementTop = $(element).offset().top;
        const elementBottom = elementTop + $(element).height();

        if (fullyInView === true) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    };

    const setBannerPosition = function (block) {
        if (isScrolledIntoView(block, false)) {
            const BANNER_TOP_INDENT = 80;
            const banners = block.find('.block-with-info__info--left, .block-with-info__info--right');

            banners.each(function () {
                const banner = $(this);
                const blockHeight = block.innerHeight();
                const bannerHeight = banner.innerHeight();

                const blockOffsetTop = block.offset().top;

                const offsetDiff = pageYOffset - blockOffsetTop;
                const bannerOffset = (offsetDiff + BANNER_TOP_INDENT) >= 0
                    ? offsetDiff + BANNER_TOP_INDENT
                    : 0;

                const bannerBottomPos = bannerOffset + bannerHeight;
                const isBannerInBottomOfBlock =  blockHeight < bannerBottomPos;

                const bannerPosition = !isBannerInBottomOfBlock
                    ? bannerOffset
                    : blockHeight - bannerHeight; // i don't know why 5px

                banner.css({
                    top: `${blockHeight > bannerHeight ? bannerPosition : 0 }px`,
                });
            });
        }
    };

    $(window).on('scroll', function () {
        if ($(window).width() > Site.breakpoints.md) {
            $('.block-with-info').each(function (index, item) {
                setBannerPosition($(item));
            })
        }
    });
});
